import React from "react";
import ProjectItem from "../ProjectItem";

const ProjectWrapperOneRow = ({ projectsWrapper, path = "projects" }) => {
	let projectFirst = projectsWrapper[0];
	let projectSecond = projectsWrapper[1];
	let projectThird = projectsWrapper[2];

	return (
		<div className="projects-list__wrapper">
			<div className="projects-list__half-wrapper">
				<div className="projects-list__item projects-list__item--quarter">
					<ProjectItem
						path={path}
						title={projectFirst.title}
						slug={projectFirst.slug}
						technologies={projectFirst.technologies}
						squaredImage={projectFirst.acfProject?.squaredImage || projectFirst.acfTheme?.squaredImage}
					/>
				</div>

				{projectSecond && (
					<div className="projects-list__item projects-list__item--quarter">
						<ProjectItem
							path={path}
							title={projectSecond.title}
							slug={projectSecond.slug}
							technologies={projectSecond.technologies}
							squaredImage={projectSecond.acfProject?.squaredImage || projectSecond.acfTheme?.squaredImage}
						/>
					</div>
				)}
			</div>

			{projectThird && (
				<div className="projects-list__item">
					<ProjectItem
						title={projectThird.title}
						slug={projectThird.slug}
						technologies={projectThird.technologies}
						squaredImage={projectThird.acfProject?.squaredImage || projectThird.acfTheme?.squaredImage}
					/>
				</div>
			)}
		</div>
	);
}

export default ProjectWrapperOneRow;
